import React from 'react';
import Game from './game/Game';

function App() {
  return (
    <Game />
  );
}

export default App;
